import { LeadOrigin } from 'constants/UpdateContactHubspot';

export function getUTMParametersFromLocation(): Record<string, string> | null {
  const urlParams = new URLSearchParams(location.search);
  const utmObject: Record<string, string> = {};

  if (urlParams.keys().next().done) {
    return null;
  }

  urlParams.forEach((value, key) => {
    const normalizedKey = key.toLowerCase();
    if (
      normalizedKey.includes('utm') ||
      normalizedKey === 'si' ||
      normalizedKey === 'plan_type' ||
      normalizedKey === LeadOrigin.QueryParam
    ) {
      utmObject[normalizedKey] = value;
    }
  });

  return utmObject;
}
